import React, {useEffect, useState} from "react";
import axios from "config/axiosConfig";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {displayMembershipStatus, formatBusinessNumber, formatPhoneNumber} from "page/util/helpers";

export default function Detail() {
    const [content, setContent] = useState();

    const navigate = useNavigate();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const userDropId = queryParams.get("userDropId");

    const requestData = (e) => {
        axios.get(`/admin/users/drops/${userDropId}`)
            .then((res) => {
                setContent(res.data);
            });
    }

    useEffect(() => {
        requestData();
    }, []);

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">탈퇴회원 > 상세</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">

                                    <div className="invoice p-3 mb-3">
                                        <div className="row">
                                            <div className="col-12">
                                                <p className="lead">탈퇴멤버정보</p>
                                                <div className="table-responsive">
                                                    <table className="table">
                                                        {
                                                            content && (
                                                                <tbody>
                                                                <tr>
                                                                    <th style={{width: "120px"}}>SEQ</th>
                                                                    <td>{content.id}</td>
                                                                    <th style={{width: "120px"}}>아이디</th>
                                                                    <td>{content.extId}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>이름</th>
                                                                    <td>{content.name}</td>
                                                                    <th>이메일</th>
                                                                    <td>{content.email}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>가입경로</th>
                                                                    <td>{content.oAuthType ?? "ALLTAX"}</td>
                                                                    <th>휴대폰</th>
                                                                    <td>{formatPhoneNumber(content.phoneNumber)}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>탈퇴일</th>
                                                                    <td colSpan={3}>{content.createdAt}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>사유</th>
                                                                    <td colSpan={3}>{content.reason}</td>
                                                                </tr>
                                                                {
                                                                    content.bizs.length > 0 && (
                                                                        <tr>
                                                                            <th>비즈정보</th>
                                                                            <td colSpan={3}>
                                                                                <table>
                                                                                    <thead>
                                                                                    <tr>
                                                                                        <td style={{borderTop: 'none'}}>사업장명</td>
                                                                                        <td style={{borderTop: 'none'}}>사업자번호</td>
                                                                                        <td style={{borderTop: 'none'}}>멤버십</td>
                                                                                        <td style={{borderTop: 'none'}}>상태</td>
                                                                                        <td style={{borderTop: 'none'}}>보기</td>
                                                                                    </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                    {
                                                                                        content.bizs && content.bizs.map( item =>
                                                                                            <tr>
                                                                                                <td>{item.name}</td>
                                                                                                <td>{formatBusinessNumber(item.number)}</td>
                                                                                                <td>{item.memberShip}</td>
                                                                                                <td>{displayMembershipStatus(item.memberShipStatus)}</td>
                                                                                                <td>
                                                                                                    <button type="button"
                                                                                                            className="btn btn-outline-info">
                                                                                                        <Link to={`/page/user/biz/detail?bizId=${item.id}`} target="_blank">보기</Link>
                                                                                                    </button>
                                                                                                </td>
                                                                                            </tr>
                                                                                        )
                                                                                    }
                                                                                    </tbody>
                                                                                </table>
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                }
                                                                </tbody>
                                                            )
                                                        }
                                                    </table>
                                                </div>
                                            </div>
                                            {/* /.col */}
                                        </div>
                                    </div>

                                    <div className="row" style={{marginTop: '30px', marginBottom: '10px'}}>
                                        <div style={{margin: "0 auto"}}>
                                            <button type="button" className="btn btn-outline-dark"
                                                    style={{marginLeft: '10px'}}
                                                    onClick={e => navigate(-1)}>
                                                목록
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </section>

                </div>
            </div>
        </div>
    );
}

